export const mobileMenuIconReducer = (state = false, action) => {
  switch (action.type) {
    case "TOGGLE_MENU":
      return action.data;

    default:
      return state;
  }
};
